import request from './request'
import * as http from '@/libs/http'

/**
 * 予約情報を延長する
 *
 * @param {Number} uid ユーザID
 * @param {Number} rid 予約ID
 * @param {Object} reserve 予約情報
 * @returns {Response} レスポンスデータ
 */
export function putReserveExtension (uid, rid, reserve) {
  return request.put(`/users/${uid}/reserves/${rid}/extension`, reserve, {
    validateStatus: (status) => [
      http.OK,
      http.Conflict,
      http.PaymentRequired,
      http.BadRequest
    ].includes(status)
  })
}
